import { Nillable } from '@web/utils';

export class AdminBoxSaleCosmeticAvailableQuantitySubmitEvent {
  public constructor(
    private readonly data: {
      amount: number;
      availableQuantity: Nillable<number>;
    },
  ) {}

  public get amount(): number {
    return this.data.amount;
  }

  public get availableQuantity(): Nillable<number> {
    return this.data.availableQuantity;
  }
}
